export const mutateTrackingInstance = trackerInstance => {
  return trackerInstance.clone({
    preserveTrackerEvents: true,
    preserveTrackerProperties: false,
    trackerName: 'pricing-pages-ui-components'
  });
};